import { Form, Input } from "antd";
import LoadableButton from "../../../../components/buttons/LoadableButton";
import ModalComponent from "../../../../components/global/modal/ModalComponent";
import { GetUserNameByTerminalIdAdpi, WithdrawScalpingApi } from "../../../../api/request/credit";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const { Search } = Input;

const WithdrawScalping = ({ isModalOpen, setIsModalOpen }) => {
    const [form] = Form.useForm();
    const [isWithdrawLoading, setIsWithdrawLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [account, setAccount] = useState({});

    const handleAccountSearch = async (accountNumber) => {
        try {
            setSearchLoading(true);
            const { data } = await GetUserNameByTerminalIdAdpi(accountNumber);
            if (data?.success) setAccount({ ...data?.data, accountNumber });
        } catch (error) {
            toast.error(error?.response?.data?.message);
            form.resetFields();
        } finally {
            setSearchLoading(false);
        }
    };

    const handleSubmit = async (values) => {
        try {
            setIsWithdrawLoading(true);
            const { data } = await WithdrawScalpingApi(values);
            if (data?.success) {
                toast.success(data?.message);
                setIsModalOpen(false);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.error?.message);
        } finally {
            setIsWithdrawLoading(false);
        }
    };

    useEffect(() => {
        if (!isModalOpen) {
            form.resetFields();
            setAccount({});
        }
    }, [isModalOpen]);

    return (
        <div>
            <ModalComponent width={400} isOpen={isModalOpen} setIsOpen={setIsModalOpen} title={<div className="font-bold text-lg">Withdraw Scalping</div>} onCancel={() => setIsModalOpen(false)}>
                <Form layout="vertical" className="flex flex-col gap-3" autoComplete="off" form={form} onFinish={handleSubmit}>

                    <Form.Item
                        name="TerminalId"
                        label={<span className="text-base text-[#2F2B3DCC] font-medium">Account Number</span>}
                        rules={[{ required: true, message: "Please enter account number" }]}
                    >
                        <Search placeholder="Search by account number" enterButton="Search" size="large" loading={searchLoading} onSearch={handleAccountSearch} />
                    </Form.Item>
                    <Form.Item
                        name="Amount"
                        label={<span className="text-base text-[#2F2B3DCC] font-medium"> Amount </span>}
                        rules={[{ required: true, message: "Please enter amount", },
                        {
                            validator: (_, value) => {
                                if (!value) {
                                    return Promise.resolve();
                                }
                                if (value <= 0) {
                                    return Promise.reject(new Error("Amount can not be negative or zero"));
                                }
                                return Promise.resolve();
                            },
                        },
                        ]}
                    >
                        <Input size="large" placeholder="Enter amount" />
                    </Form.Item>


                    {account?.fullName && (
                        <table className="w-full text-base text-[#2F2B3DCC] font-medium border ">
                            <tbody>
                                <tr className="border-b">
                                    <td className="py-2 px-3 font-semibold border-r"> Name </td>
                                    <td className="py-2 px-3"> {account?.fullName} </td>
                                </tr>
                                <tr className="border-b">
                                    <td className="py-2 px-3 font-semibold border-r"> Balance </td>
                                    <td className={`py-2 px-3 ${account?.balance < 0 ? "text-red-600" : "text-green-600"}`} > {account?.balance} </td>
                                </tr>
                                <tr>
                                    <td className="py-2 px-3 font-semibold border-r"> Scalping P/L </td>
                                    <td className="py-2 px-3 text-blue-600" > {account?.scalping} </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <div className="flex justify-end items-center gap-3 mt-8">
                        <button onClick={() => setIsModalOpen(false)} className="bg-[var(--theme2)] text-sm text-white font-semibold rounded-lg px-3 py-2">Cancel</button>
                        <LoadableButton
                            className="bg-primary text-sm text-white font-semibold rounded-lg px-3 py-2"
                            type="Submit"
                            lable="Withdraw"
                            isLoading={isWithdrawLoading}
                            loadingLable="Requesting..."
                        />
                    </div>
                </Form>
            </ModalComponent>
        </div>
    )
}

export default WithdrawScalping